//Button Types and Sizes

export const BUTTON_STYLE_TYPE = {
    PRIMARY: 'xbtn__primary',
    CANCEL: 'xbtn__cancel',
    CARD: 'xbtn__card',
    ICON: 'xbtn__icon',
    PASSWORD: 'xbtn__icon__password',
    WARNING: 'xbtn__warning',
    INFO: 'xbtn__info',
    WARNING_DISABLED: 'xbtn__warning_disabled',
    NAV: 'xbtn__nav',
    FAQ_NAV: 'xbtn__faq-nav',
    DISABLED: 'xbtn__nav_disabled',
    DISABLED_PRIMARY: 'disabled',
    LB_BUTTON: 'xbtn__lb_button',
    LB_BUTTON_V2: 'xbtn__lb_button_v2',
}

export const BUTTON_SIZE = {
    SMALL: 'xbtn__small',
    ICON_MOBILE: 'xbtn__icon__mobile',
    ICON_LARGE: 'xbtn__icon__large',
    ICON_LARGER: 'xbtn__icon__larger',
}

// Link Types and Sizes
export const LINK_SIZE = {
    SMALL: 'xlink__small',
    MEDIUM: 'xlink_medium',
}
export const LINK_TYPE = {
    ICON: 'xlink__icon',
    WARNING: 'xlink__warning',
}

//Text Types and Sizes
export const XTEXT_TYPE = {
    HREF: 'xtext__href',
    ERROR: 'xtext__error',
    INPUT: 'xtext__input',
    TEXT: 'xtext__text',
    LABEL: 'xtext__label',
}

export const XTEXT_SIZE = {
    SMALLEST: 'xtext__smallest',
    SMALL: 'xtext__small',
    SMALL_EXTRA: 'xtext__small_extra',
    MEDIUM: 'xtext__medium',
    MEDIUM_EXTRA: 'xtext__medium_extra',
    MEDIUM_BIGGER: 'xtext__medium_bigger',
    MEDIUM_BIGGER_BOLDED: 'xtext__medium_bigger-bolded',
    LARGE: 'xtext__large',
    EXTRA_LARGE: 'xtext__extra-large',
    TRANSFER_METHOD: 'xtext__transfer-method',
    DISCLAIMER: 'xtext__disclaimer',
    LARGE_SEMI_BOLDED: 'xtext__large_semi-bolded',
    LARGE_UNBOLDED: 'xtext__large_unbolded',
    LB_TITLE: 'xtext__lb_title',
    LB_SUBTITLE: 'xtext__lb_subtitle',
}
export const XTEXT_ALIGNMENT = {
    CENTER: 'xtext__center',
    RIGHT: 'xtext__right',
    LEFT: 'xtext__left',
}

export const XTEXT_DECORATIONS = {
    REGULAR: 'xtext',
    BOLD: 'xtext__bold',
    ITALIC: 'xtext__italic',
}

export const XTEXT_MARGINS = {
    NO_MARGINS: 'xtext__no_margins',
    DEFAULT: '',
}
